import { DateTime } from 'luxon'

export default {
  methods: {
    FormataStringDataSGP(data) {
      if (data) {
        var time = data.split(' ')[1]
        data = data.split(' ')[0]
        var dia = data.split('/')[0]
        var mes = data.split('/')[1]
        var ano = data.split('/')[2]
        return ano + '-' + ('0' + mes).slice(-2) + '-' + ('0' + dia).slice(-2) + 'T' + time + 'Z'
      }
    },
    FormataTimeStampSGP(data, timeEnviado, dataFinal) {
      if (data) {
        var datax = data.split('T')[0]
        var dia = datax.split('-')[2]
        var mes = datax.split('-')[1]
        var ano = datax.split('-')[0]
        if (dataFinal) {
          dataFinal = dia + dataFinal
        } else {
          dataFinal = dia
        }
        if (timeEnviado) {
          var time = timeEnviado.split('T')[1]
          time = time == null ? timeEnviado : time
        }
        return ano + '-' + ('0' + mes).slice(-2) + '-' + ('0' + dataFinal).slice(-2) + 'T' + time
      }
    },
    dataHoraTipoSGP(hora, dataFinal, dataInicial) {
      var dNow = dataInicial
      if (dNow) {
        dNow = this.FormataTimeStampSGP(dataInicial, hora, dataFinal)
        return dNow
      } else {
        dNow = DateTime.local()
        if (dataFinal) {
          dataFinal = dNow.day + dataFinal
        } else {
          dataFinal = dNow.day
        }
        return (
          dNow.year +
          '-' +
          ('0' + dNow.month).slice(-2) +
          '-' +
          ('0' + dataFinal).slice(-2) +
          'T' +
          hora +
          'Z'
        )
      }
    },
    getHourSGP(time) {
      if (time) {
        time = time.split('T')[1]
        return time.slice(0, 5)
      }
    },
    capturaDataAtualSGP() {
      var local = DateTime.local()
      return local.toString()
    }
  }
}
